<template lang="pug">
  #inicio-respuestas2
    .container-fluid
      //- .row
      //-   .title.mx-auto.d-flex
      //-     img(src="/assets/img/microsite/Amenaza.png")
      .row.content-s1.d-flex
        .col-md-5
          img.covid(src="/assets/img/mapa-intro.png")
        .col-11.col-md-7.text.pr-4.d-flex.pl-0
          p.sub-title.accent-yellow-text.mb-0 Los peores estados para
          p.sub-title.neutral-text.bold contraer Covid-19 en México
          p.subtext.accent-yellow-text La ventaja de la juventud de la población que México pudo haber tenido frente al COVID-19 se ve opacada por los múltiples padecimientos que hacen vulnerable a su población, así como la limitada infraestructura hospitalaria de cada estado. ¿Qué estados son los más vulnerables ante la contingencia y por qué?
          router-link.story-btn(to="/la-respuesta-estados#ch3intro") Leer Blog




</template>

<script>

export default {
  name: "Section2s1"
};
</script>

<style lang="scss">
#inicio-respuestas2 {
  min-height: 100vh;
  padding: 1rem 0;
  margin-top: 5rem;
  .title {
    justify-content: center;
    align-items: center;
    img {
      width: 30vw;
      max-width: 300px;
    }
  }
  .content-s1 {
    min-height: 85vh;
    background-image: url("/assets/img/microsite/desktop_back.png");
    background-size: 100% 100%;
    text-align: center;
    justify-content: center;
    align-items: center;
    .covid {
      margin: 0;
      width: 100%;
      max-width: 650px;
      text-align: center;
    }
    .text {
      flex-direction: column;
      text-align: center;
      justify-content: center;
      align-items: center;
      line-height: 1;
      .subtext {
        line-height: 1.75;
      }
      a {
        color: #fff;
      }
      .story-btn {
        font-family: "Oswald", sans-serif;
        border: solid 3px #f0bf5f;
        border-radius: 45px;
        font-size: 1.2rem;
        padding: 0.5rem 3.5rem;
        margin: 2rem auto;
      }
      .story-btn:hover {
        background-color: #f0bf5f;
      }
    }
  }
}
// Small devices
@media (max-width: 767px) {
  #inicio-respuestas2 {
    .title {
      img {
        width: auto;
        max-width: 225px;
      }
    }
    .sub-title {
      font-size: 1.7rem;;
    }
    .content-s1 {
      min-height: 0;
      background-image: url("/assets/img/microsite/mobile_back.png");
      padding: 2rem 0;
      .covid {
        width: 80vw;
        max-width: 460px;
        margin-bottom: 1rem;
      }
      .text {
        .subtext {
          font-size: 0.8rem;
          line-height: 1.5;
          max-width: 90%;
        }
        .story-btn {
          font-family: "Oswald", sans-serif;
          border: solid 2px #f0bf5f;
          border-radius: 35px;
          font-size: 1rem;
          padding: 0.5rem 2.5rem;
          margin: 1rem auto 2rem auto;
        }
      }
    }
  }
}
</style>
